import React from 'react';
import { motion } from 'framer-motion';
import Icon from 'components/AppIcon';

const StatusBadge = ({ status, size = 'md' }) => {
  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        bg: 'bg-yellow-500/20',
        text: 'text-yellow-400',
        border: 'border-yellow-500/30',
        icon: 'Clock',
        label: 'Pending'
      },
      'in-progress': {
        bg: 'bg-blue-500/20',
        text: 'text-blue-400',
        border: 'border-blue-500/30',
        icon: 'Play',
        label: 'In Progress'
      },
      completed: {
        bg: 'bg-green-500/20',
        text: 'text-green-400',
        border: 'border-green-500/30',
        icon: 'CheckCircle',
        label: 'Completed'
      },
      cancelled: {
        bg: 'bg-red-500/20',
        text: 'text-red-400',
        border: 'border-red-500/30',
        icon: 'XCircle',
        label: 'Cancelled'
      },
      draft: {
        bg: 'bg-gray-500/20',
        text: 'text-gray-400',
        border: 'border-gray-500/30',
        icon: 'Edit',
        label: 'Draft'
      },
      submitted: {
        bg: 'bg-purple-500/20',
        text: 'text-purple-400',
        border: 'border-purple-500/30',
        icon: 'Send',
        label: 'Submitted'
      },
      'in_review': {
        bg: 'bg-orange-500/20',
        text: 'text-orange-400',
        border: 'border-orange-500/30',
        icon: 'Eye',
        label: 'In Review'
      },
      done: {
        bg: 'bg-green-500/20',
        text: 'text-green-400',
        border: 'border-green-500/30',
        icon: 'Check',
        label: 'Done'
      }
    };

    return configs[status] || configs.pending;
  };

  const sizeConfig = {
    sm: {
      padding: 'px-2 py-1',
      text: 'text-xs',
      icon: 12
    },
    md: {
      padding: 'px-3 py-1.5',
      text: 'text-sm',
      icon: 14
    },
    lg: {
      padding: 'px-4 py-2',
      text: 'text-base',
      icon: 16
    }
  };

  const config = getStatusConfig(status);
  const sizing = sizeConfig[size];

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
      className={`
        inline-flex items-center space-x-2 rounded-full border
        ${config.bg} ${config.text} ${config.border}
        ${sizing.padding} ${sizing.text}
        backdrop-blur-sm
      `}
    >
      <Icon name={config.icon} size={sizing.icon} />
      <span className="font-medium">{config.label}</span>
    </motion.div>
  );
};

export default StatusBadge;